import Vue from "vue";
import Vuex from "vuex";

import models from '../content-structure/models';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    route: models.defaultState.route,

    dataLists: {},
    indexes: {},

    maxListLength: 6,

    chartModel:  {},

    checkbox: [],

    currentModal: null
  },

  getters: {
    activeRoute: (state) => state.route,
    activeDataList: (state, getters) => {
      // console.log('getter.activeDataList: ', state.dataLists)
      return state.dataLists[getters.activeRoute.value] || []
    },
    activeCard: (state) => state.chartModel || {},
    activeIndex: (state, getters) => {
      return state.indexes[getters.activeRoute.value] || 0
    },
    activeToggles: (state, getters) => {
      return getters.activeCard.content[0].config.legend || []
    },
    //
    activeChecks: (state) => state.checkbox || [],
    activeModal: (state) => state.currentModal || null,

    maxListLength: (state) => state.maxListLength || 6
  },

  mutations: {
    setActiveRoute(state, payload) {
      // console.log('setActiveRoute state payload ', state, payload)
      const newState = state;
      newState.route = payload;

      // need to also set active card on route change
      const newIndex = newState.indexes[payload.value]
      if (newIndex !== undefined) {
        Vue.set(state, 'chartModel', newState.dataLists[payload.value][newIndex]);
      }
      Vue.set(state, 'route', payload);
    },

    setActiveDataList(state, payload) {
      // console.log('setActiveDataList state payload ', state, payload)
      let data = [];
      data = state.dataLists[state.route.value] || [];
      // console.log("setActiveDataList state: ", state)
      data.push(payload);
      Vue.set(state.dataLists, state.route.value, data);
      localStorage.setItem('datalists', JSON.stringify(state.dataLists));
    },

    removeFromActiveDataList(state, payload) {
      let dataList = [];
      dataList = state.dataLists[state.route.value] || [];
      let newIndex = state.indexes[state.route.value];
      let removedIndex = -1;

      dataList = dataList.filter(function(el, index){
        if (el.tileId === payload.tileId) {
          removedIndex = index;
        }
        return el.tileId !== payload.tileId;
      });

      // ensure remove displays correct card
      // preserve correct card placement if menu removes an item that
      // preceds the active card in the card list
      if (newIndex >= dataList.length || removedIndex < newIndex){
        newIndex--;
      }

      Vue.set(state.dataLists, state.route.value, dataList);
      Vue.set(state.indexes, state.route.value, newIndex);
      Vue.set(state, 'chartModel', dataList[newIndex]);
      localStorage.setItem('datalists', JSON.stringify(state.dataLists));
    },

    setClearDataList(state) {
      Vue.set(state.dataLists, state.route.value, []);
      localStorage.setItem('datalists', JSON.stringify(state.dataLists));
    },

    setActiveCard(state, payload) {
      // console.log("setActiveCard state payload ", state, payload)
      state.chartModel = payload;
    },

    setActiveIndex(state, payload) {
      Vue.set(state.indexes, state.route.value, payload);
      localStorage.setItem('indexes', JSON.stringify(state.indexes))
    },

    setActiveCheck(state, payload) {
      state.checkbox = payload;
    },

    setCurrentModal(state, payload) {
      state.currentModal = payload;
    },

    setChartData(state, payload) {
      // replace data in datalist
      const newDataLists = {...state.dataLists};
      let updateIndex = 0;

      const activeData = newDataLists[payload.trial].map((card, cardIndex) => {
        card.content.forEach((item, index) => {
          if (item.config && item.config.id === payload.id) {
            updateIndex = cardIndex;
            item.config.legend.forEach(item => {
              item.entries.forEach(ent => {
                item.active = payload.activeSets.includes(ent.entry)
              })
            })
            item.data = item.dataSrc.filter(set => {
              return payload.activeSets.includes(set.name)
            })
          }
        })

        return card
      })

      newDataLists[payload.trial] = activeData;
      Vue.set(state, 'dataLists', newDataLists);

      const updatedChartModel = {...state.dataLists[payload.trial][updateIndex]}
      Vue.set(state, 'chartModel', updatedChartModel)
    }
  },

  actions: {
    getActiveRoute({ commit }, route) {
      // console.log('getActiveRoute ', route)
      commit('setActiveRoute', route);
      localStorage.setItem('route', route);
    },

    //
    getActiveDataList({ commit }, obj) {
      commit('setActiveDataList', obj);
    },

    removeFromActiveDataList({ commit }, obj) {
      // console.log('removeFromActiveList', obj)
      commit('removeFromActiveDataList', obj)
    },

    clearActiveDataList({ commit }) {
      commit('setClearDataList');
    },

    getActiveCard({ commit }, obj) {
      // console.log('getActiveCard', obj);
      commit('setActiveCard', obj);
      localStorage.setItem('chart', JSON.stringify(obj));
    },

    updateActiveIndex({ commit }, id) {
      commit('setActiveIndex', id);
    },

    updateChartData({ commit }, obj) {
      // console.log('updateChartData', obj)
      commit('setChartData', obj);
    },

    //
    getActiveChecks({ commit }, arr) {
      commit('setActiveCheck', arr);
      localStorage.setItem('checks', JSON.stringify(arr));
    },

    //modals
    getCurrentModal({ commit }, string) {
      commit('setCurrentModal', string)
    }
  },
});
